import { Injectable } from '@angular/core';
import { ISelectResponse } from '@shared/models/select-response';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor() { }

  /**
   * Filtra elementos de un array basado en una propiedad específica y un valor de búsqueda.
   *
   * @param searchItem Valor ingresado para buscar.
   * @param array Array de objetos a filtrar.
   * @param property Nombre de la propiedad del objeto a comparar.
   * @returns Array filtrado que contiene coincidencias con el valor buscado.
   */
  filterSelect<T extends Record<string, any>>(searchItem: ISelectResponse, array: T[], property: keyof T | (keyof T)[]): T[] {
    const filterValue = searchItem?.toString().toLowerCase() ?? '';

    if (!Array.isArray(array)) {
      console.error(`El segundo parámetro debe ser un array`, array);
      return [];
    }

    return array.filter((item) => {
      if (Array.isArray(property)) {
        // Si es un array de propiedades, devuelve true si alguna propiedad incluye el valor
        return property.some((prop) =>
          item[prop]?.toString().toLowerCase().includes(filterValue)
        );
      } else {
        // Si es una sola propiedad
        return item[property]?.toString().toLowerCase().includes(filterValue);
      }
    });
  }

}
